import React from 'react';
import { Depths, IconButton, Panel, PanelType, Persona, PrimaryButton, TextField, getTheme } from '@fluentui/react';

export const Members = (props) => {
  const {members, setMembers} = props;
  const [showAddUserPanel, toggleshowAddUserPanel] = React.useState(false);

  const [newUser, setNewUser] = React.useState({name: '', workload: [], projects: []});

  const addMember = () => {
    setMembers(prev => prev.concat({...newUser, id: Date.now()}));
    setNewUser({name: '', workload: [], projects: []});
  }

  return <div className='mt-4'>
    <h2>
      Members
      {/* <IconButton 
        styles={{
          root: {marginLeft: 16, background: getTheme().palette.themeSecondary, borderRadius: '50%', color: "#fff"},
          rootHovered: {background: getTheme().palette.themePrimary, color: "#fff", boxShadow: Depths.depth16}
        }} 
        iconProps={{iconName: "Add"}} onClick={() => toggleshowAddUserPanel(true)} /> */}
    </h2>
    {
      members.map(mem => {
        return <Persona styles={{root: {marginBottom: 8}}} key={mem.id} text={mem.name} />
      })
    }
    <Panel headerText='Add Member' type={PanelType.medium} isOpen={showAddUserPanel} onDismiss={() => toggleshowAddUserPanel(false)}>
      <TextField styles={{root: {marginBottom: 16}}} value={newUser.name} onChange={(e, val) => setNewUser(prev => ({...prev, name: val}))} label='Name' />
      <PrimaryButton text="Add Member" disabled={!newUser.name} onClick={addMember} />
    </Panel>
  </div>
}